// import moment from "moment";
import moment from "moment-timezone";
import { vocabularize } from "src/Common/vocab";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import imageCompression from "browser-image-compression";

import { formatDate, getImageUrl, getServiceTicketUrl, UtcToMst } from "src/Common/common";
import { can, handleError, isAccountant, isAdmin, isClericalOver, isManagerOver } from "src/Common/function";
import Loader from "src/Components/Common/Loader";
import Button from "src/Components/Button";
import BlueButton from "src/Components/Common/bluebutton";
import WhiteUploadButton from "src/Components/Common/whiteuploadbutton";
import CreateButton from "src/Components/CreateButton";
import CreatePoButton from "src/Pages/WO/details/CreatePoButton";
import CustomerInformation from "src/Pages/WO/details/CustomerInformation";
import ServiceCall from "src/Pages/WO/details/ServiceCall";
import useWONotesRealtime from "src/hooks/useWONotesRealtime";
import useWoTechStatusRealtime from "src/hooks/useWoTechStatusRealtime";
import { setWONumber } from "src/Redux/Slices/HeaderSlice";
import POService from "src/Services/API/po.service";
import TechnicianService from "src/Services/API/technician.service";
import UserService from "src/Services/API/user.service";
import WOService from "src/Services/API/wo.service";
import AssignTechModal from "../Components/AssignTech/assigntechmodal";
import ScheduleModal from "../Components/ScheduleModal";
import BilledDateModal from "../Components/billeddatemodal";
import CreateWoModal from "../Components/createwomodal";
import CreatePoModal from "src/Pages/WO/Components/createpomodal/CreatePoModal";
import PreviewSTModal from "../Components/previewstmodal";
import ConfirmDialog from "src/Common/confirmdialog";
import ApproveModal from "../Components/ApproveModal";
import NoteService from "src/Services/API/note.service";
import ViewButton from "../Components/attachment/ViewButton";
import WoCustomerChat from "../Components/notes/WoCustomerChat";
import WoAdminNotes from "../Components/adminnote/WoAdminNotes";
import WoTechNotes from "../Components/technote/WoTechNotes";
import WoPos from "../Components/pos/WoPos";
import WoTimesheet from "../Components/timesheet/WoTimesheet";
import WoHistory from "../Components/history/WoHistory";
import AddFormModal from "../Components/forms/AddFormModal";
import WoForms from "../Components/forms/WoForms";
import AttachmentImageSlider from "../Components/attachment/AttachmentImageSlider";
import TechnicalDocuments from "../Components/technicaldocuments/TechnicalDocuments";
import JobsitePhotos from "../Components/jobsitephotos/JobsitePhotos";
import WoProposals from "../Components/proposals/WoProposals";
import WoInvoices from "../Components/invoices/WoInvoices";
import { connectWONotesSocket, disconnectWONotesSocket } from "src/Services/socket/woNotesSocket";

function WODetail() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const currentUser = UserService.getCurrentUser();
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [editingPO, setEditingPO] = useState(null);
  const [isAssignTechModalShown, setIsAssignTechModalShown] = useState(false);
  const [isSavingAssigns, setIsSavingAssigns] = useState(false);
  const attachmentFile = useRef(null);
  const attachmentDragCounter = useRef(0);
  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
  const [cratePOModalShown, setCratePOModalShown] = useState(false);
  const [approveModalShown, setApproveModalShown] = useState(false);
  const [stPreviewModalShown, setSTPreviewModalShown] = useState(false);
  const [stPreviewLoading, setStPreviewLoading] = useState(false);
  const [isWoCreateOpen, setIsWoCreateOpen] = useState(false);
  //billed date
  // const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [billedDateModalShown, setBilledDateModalShown] = useState(false);
  const [addFormModalShown, setAddFormModalShown] = useState(false);

  const [isAttachmentSliderShown, setIsAttachmentSliderShown] = useState(false);
  const [sliderAttachments, setSliderAttachments] = useState([]);
  const [sliderActiveIndex, setSliderActiveIndex] = useState(0);
  //attachment delete confirmation
  const [attachmentDeleteModalShown, setAttachmentDeleteModalShown] = useState(false);
  // const [attachmentToDeleteIndex, setAttachmentToDeleteIndex] = useState(-1);
  const [attachmentToDelete, setAttachmentToDelete] = useState(null);

  const [isUploadingAttachment, setIsUploadingAttachment] = useState(false);
  const [isAttachmentDragActive, setIsAttachmentDragActive] = useState(false);
  const [isAttachmentDragInvalid, setIsAttachmentDragInvalid] = useState(false);
  const [poListRefreshToken, setPoListRefreshToken] = useState(0);
  const [adminNotesRefreshToken, setAdminNotesRefreshToken] = useState(0);
  const [techNotesRefreshToken, setTechNotesRefreshToken] = useState(0);

  //forms
  // const [isFormBuilderModalShown, setIsFormBuilderModalShown] = useState(false);

  const openAttachmentSlider = (attachments, activeIndex = 0) => {
    if (!attachments?.length) return;
    setSliderAttachments(attachments);
    setSliderActiveIndex(activeIndex);
    setIsAttachmentSliderShown(true);
  };

  useEffect(() => {
    WOService.getWorkOrderById(id)
      .then((response) => {
        if (response.status == 200) {
          setOrder(response.data);
          dispatch(setWONumber(String(response.data.number)));
        }
      })
      .catch((error) => handleError(error));
  }, [id]);

  const approveRequest = (serviceType, startDate, primaryTech) => {
    let data = {};

    data = {
      status: 1,
      serviceType: serviceType,
      openDate: new Date(),
      openUser: currentUser,
      eventUser: currentUser,
    };

    if (startDate) {
      data.startDate = formatDate(startDate, "YYYY-MM-DD");
    }

    WOService.approve({
      id: order.id,
      data,
    })
      .then(async (response) => {
        console.log("approveRequest: ", response.data);
        if (response.status == 201) {
          if (primaryTech) {
            try {
              await TechnicianService.createTechnician({
                woId: response.data.id,
                data: [{ user: primaryTech.id, roleId: 0 }],
                eventUser: currentUser,
              });
            } catch (error) {
              handleError(error);
            }
          }
          getWODetail(order.id);
          toast(vocabularize("Work order approved successfully"));
          setApproveModalShown(false);
          dispatch(setWONumber(String(response.data.number)));
        }
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const denyRequest = () => {};

  const saveAssigns = async (dataParam) => {
    // Guard against double-clicks: a second SAVE before the first request settles
    // (and before `order` state refreshes) would re-create the same techs.
    if (isSavingAssigns) return;
    setIsSavingAssigns(true);

    let data = dataParam.filter((item) => item.user !== -1 && item.roleId !== -1);
    setIsAssignTechModalShown(false);

    try {
      if (order.assignedTechs.length > 0) {
        // Keep the row id so duplicate assignments of the same user can be
        // removed individually. `remaining` tracks which existing rows are still
        // matched by the new selection; whatever is left over gets deleted.
        let remaining = order.assignedTechs.map((item) => ({
          id: item.id,
          user: item.user.id,
          roleId: item.roleId,
        }));

        let newTechArray = [],
          updatedTechArray = [];

        for (let item of data) {
          // Match one existing row for this user (consume it so duplicates in
          // `remaining` aren't all matched by a single new selection).
          const matchIndex = remaining.findIndex((obj) => obj.user === item.user);
          if (matchIndex === -1) {
            newTechArray.push(item);
          } else {
            const matched = remaining[matchIndex];
            if (matched.roleId !== item.roleId) {
              updatedTechArray.push(item);
            }
            remaining.splice(matchIndex, 1);
          }
        }

        // Anything still in `remaining` was not matched -> remove it by row id.
        // This also clears leftover duplicate rows for a user.
        const removedTechArray = remaining;

        await TechnicianService.createTechnician({
          woId: order.id,
          data: newTechArray,
          eventUser: currentUser,
        });
        await TechnicianService.deleteTechnician({
          woId: order.id,
          data: removedTechArray,
          eventUser: currentUser,
        });
        await TechnicianService.updateBulkTechnician({
          woId: order.id,
          data: updatedTechArray,
        });
      } else {
        const response = await TechnicianService.createTechnician({
          woId: order.id,
          data,
          eventUser: currentUser,
        });
        if (response.status == 201) {
          toast("Techs assigned successfully");
        } else {
          toast("An error occured");
        }
      }

      await getWODetail(order.id);
    } catch (error) {
      handleError(error);
    } finally {
      setIsSavingAssigns(false);
    }
  };

  const resetDragState = (type) => {
    if (type === 1) {
      attachmentDragCounter.current = 0;
      setIsAttachmentDragActive(false);
      setIsAttachmentDragInvalid(false);
    }
  };

  const isAllowedUploadFile = (file) => {
    if (!file) return false;
    const type = (file.type || "").toLowerCase();
    if (type.startsWith("image/") || type === "application/pdf") return true;
    const name = (file.name || "").toLowerCase();
    return /\.(png|jpe?g|gif|bmp|webp|svg|heic|heif|tiff?|pdf)$/.test(name);
  };

  const filterAllowedUploadFiles = (files = []) => {
    const allowed = [];
    let rejectedCount = 0;
    files.forEach((file) => {
      if (isAllowedUploadFile(file)) {
        allowed.push(file);
      } else {
        rejectedCount += 1;
      }
    });
    if (rejectedCount > 0) {
      toast(`${rejectedCount} file${rejectedCount > 1 ? "s were" : " was"} skipped. Only images and PDFs are allowed.`);
    }
    return allowed;
  };

  const isAllowedUploadDragType = (type = "") => {
    const t = type.toLowerCase();
    return t.startsWith("image/") || t === "application/pdf";
  };

  const hasInvalidDragItems = (dataTransfer) => {
    if (!dataTransfer) return false;
    const items = dataTransfer.items ? Array.from(dataTransfer.items) : [];
    const fileItems = items.filter((item) => item.kind === "file");
    if (fileItems.length === 0) return false;
    return fileItems.some((item) => !isAllowedUploadDragType(item.type));
  };

  const handleUploadFiles = async (type, files = []) => {
    const options = {
      maxSizeMB: 5,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };

    if (files.length === 0) return;

    if (type === 1) {
      setIsUploadingAttachment(true);
    }

    try {
      let compressedFiles = [];
      for (let file of files) {
        const isImage = file.type.startsWith("image/");
        if (isImage && file.size > 5242880) {
          const compressedBlob = await imageCompression(file, options);
          const compressedFile = new File([compressedBlob], file.name, {
            type: compressedBlob.type,
            lastModified: Date.now(),
          });
          compressedFiles.push(compressedFile);

          console.log("Original:", file.size / 1024 / 1024, "MB");
          console.log("Compressed:", compressedFile.size / 1024 / 1024, "MB");
        } else {
          compressedFiles.push(file);
        }
      }

      const response = await WOService.uploadFiles(compressedFiles, order.id, type, currentUser);
      if (response.status == 201) {
        toast(`${compressedFiles.length} file${compressedFiles.length > 1 ? "s" : ""} uploaded successfully`);
        let temp = { ...order };
        if (type === 1) {
          temp.attachments = response.data;
        }
        setOrder(temp);
      } else {
        toast("Something went wrong");
      }
    } catch (error) {
      handleError(error);
    } finally {
      if (type === 1) {
        setIsUploadingAttachment(false);
      }
    }
  };

  const fileSelected = async (type, e) => {
    const input = e.target;
    const files = Array.from(input?.files || []);
    await handleUploadFiles(type, files);
    if (input) input.value = null;
  };

  const handleDragEnter = (type, e) => {
    e.preventDefault();
    e.stopPropagation();

    if (type === 1 && isUploadingAttachment) return;

    const invalid = hasInvalidDragItems(e.dataTransfer);

    if (type === 1) {
      attachmentDragCounter.current += 1;
      setIsAttachmentDragActive(true);
      setIsAttachmentDragInvalid(invalid);
    }
  };

  const handleDragOver = (type, e) => {
    e.preventDefault();
    e.stopPropagation();

    if (type === 1 && isUploadingAttachment) return;

    const invalid = hasInvalidDragItems(e.dataTransfer);

    if (type === 1) {
      setIsAttachmentDragActive(true);
      setIsAttachmentDragInvalid(invalid);
    }
  };

  const handleDragLeave = (type, e) => {
    e.preventDefault();
    e.stopPropagation();

    if (type === 1 && isUploadingAttachment) return;

    if (type === 1) {
      attachmentDragCounter.current = Math.max(attachmentDragCounter.current - 1, 0);
      if (attachmentDragCounter.current === 0) {
        setIsAttachmentDragActive(false);
        setIsAttachmentDragInvalid(false);
      }
    }
  };

  const handleDrop = async (type, e) => {
    e.preventDefault();
    e.stopPropagation();

    if (type === 1 && isUploadingAttachment) return;

    const files = Array.from(e.dataTransfer.files || []);
    resetDragState(type);
    const allowedFiles = filterAllowedUploadFiles(files);
    if (allowedFiles.length === 0) return;
    await handleUploadFiles(type, allowedFiles);
  };

  const saveScheduledStartTargetDate = (startDate, targetDate) => {
    setIsScheduleModalOpen(false);
    if (!startDate && !targetDate) return;
    let data = {};
    if (startDate) {
      data["scheduledStartDate"] = startDate;
      // data["startDateForTimesheet"] = startDate.format("YYYY-MM-DD HH:mm:ss");
    }
    if (targetDate) {
      data["scheduledTargetDate"] = targetDate;
    }

    WOService.update({ id: order.id, data: data })
      .then((response) => {
        console.log("saveStartTargetDate: ", response);
        if (response.status == 201) {
          setOrder(response.data);
          toast("Date saved successfully");
        } else {
          toast("something went wrong!");
        }
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const saveBilledDate = (date, billedNote) => {
    setBilledDateModalShown(false);

    let billedData = order.billedData;
    if (billedData) {
      billedData.push({
        date: formatDate(date, "MM/DD/YYYY"),
        note: billedNote,
      });
    } else {
      billedData = [{ date: formatDate(date, "MM/DD/YYYY"), note: billedNote }];
    }

    WOService.setBilledDate({
      id: order.id,
      data: { billedData, eventUser: currentUser },
    })
      .then((response) => {
        console.log("saveBilledtDate: ", response);
        if (response.status == 201) {
          setOrder(response.data);
          toast("Billed date saved successfully");
        } else {
          toast("something went wrong!");
        }
      })
      .catch((error) => {
        handleError(error);
      });
  };

  // const uploadClicked = () => {
  //   inputFile.current.click();
  // };

  const navigatePODetail = (po) => {
    POService.getPurchaseOrdersByPoId(po.id)
      .then((response) => {
        if (response.status == 200) {
          navigate("/purchase/" + response.data.id, {
            state: { order: response.data },
          });
        }
      })
      .catch((error) => handleError(error));
  };

  const createPO = () => {
    setEditingPO(null);
    setCratePOModalShown(true);
  };

  const getWODetail = (id) => {
    return WOService.getWorkOrderById(id)
      .then((response) => {
        console.log("save assigned techs: ", response);
        if (response.status == 200) {
          setOrder(response.data);
        }
      })
      .catch((error) => handleError(error));
  };

  const refreshPurchaseOrders = () => {
    setPoListRefreshToken((prevToken) => prevToken + 1);
  };

  const refreshAdminNotes = () => {
    setAdminNotesRefreshToken((prevToken) => prevToken + 1);
  };

  const refreshTechNotes = () => {
    setTechNotesRefreshToken((prevToken) => prevToken + 1);
  };

  useWONotesRealtime({
    woId: order?.id,
    onAdminRefresh: refreshAdminNotes,
    onTechRefresh: refreshTechNotes,
  });

  const handleTechStatusChanged = useCallback((payload) => {
    setOrder((prevOrder) => {
      if (!prevOrder?.assignedTechs?.length) {
        return prevOrder;
      }

      let didChange = false;
      const nextAssignedTechs = prevOrder.assignedTechs.map((tech) => {
        const matchesTechId = payload.technicianId !== undefined && Number(tech.id) === Number(payload.technicianId);
        const matchesUserId = payload.userId !== undefined && Number(tech?.user?.id) === Number(payload.userId);

        if (!matchesTechId && !matchesUserId) {
          return tech;
        }

        if (Number(tech.techStatus) === Number(payload.techStatus)) {
          return tech;
        }

        didChange = true;
        return { ...tech, techStatus: payload.techStatus };
      });

      if (!didChange) {
        return prevOrder;
      }

      return { ...prevOrder, assignedTechs: nextAssignedTechs };
    });
  }, []);

  useWoTechStatusRealtime({
    woId: order?.id,
    onTechStatusChanged: handleTechStatusChanged,
  });

  // Closes the modal only on success — on failure it stays open (with the
  // user's input intact) so the submit can be retried.
  const savePO = async (data) => {
    if (editingPO) {
      try {
        //upload receipts
        // for (let file of data.data.receipts) {
        //   const fileName = `PO receipt_${String(Math.floor(Date.now()))}.png`;
        //   const fileData = { id: data.id, name: fileName, base64: file.base64 };
        //   console.log(fileData);
        //   await POService.attachFile(fileData);
        // }

        //save data
        let response = await POService.update(data);
        if (response.status == 201) {
          setCratePOModalShown(false);
          toast("Purchase order updated successfully!");
          refreshPurchaseOrders();
          getWODetail(order.id);
        }
      } catch (error) {
        handleError(error);
      }
    } else {
      try {
        const response = await POService.savePurchaseOrder(data);
        if (response.status == 201) {
          for (let file of data.po.receipts || []) {
            await POService.uploadFile(file.file, response.data.id);
          }

          setCratePOModalShown(false);
          toast("Purchase order created successfully!");
          refreshPurchaseOrders();

          WOService.getWorkOrderById(order.id)
            .then((response) => {
              console.log("response: ", response);
              if (response.status == 200) {
                setOrder(response.data);
              }
            })
            .catch((error) => handleError(error));
        }
      } catch (error) {
        handleError(error);
      }
    }
  };

  const showPreviewModal = () => {
    setStPreviewLoading(true);
    WOService.previewServiceTicket(order.id)
      .then((response) => {
        if (response.status == 200) {
          setSTPreviewModalShown(true);
        }
      })
      .catch((error) => {
        handleError(error);
      })
      .finally(() => {
        setStPreviewLoading(false);
      });

    // WOService.attachMaterials({ id: order.id, data: {} })
    //   .then((response) => {
    //     console.log(response.status);
    //     if (response.status == 201) {
    //     }
    //   })
    //   .catch((error) => handleError(error));
  };

  const closeWorkOrder = () => {
    WOService.update({ id: order.id, data: { status: 100 } })
      .then((response) => {
        console.log("status update to CLOSE: ", response);
        if (response.status == 201) {
          setOrder(response.data);
        }
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const handleScheduleEdit = () => {
    setIsScheduleModalOpen(true);
  };

  const saveWO = (data) => {
    setIsWoCreateOpen(false);
    return WOService.update({
      id: order.id,
      data: { ...data, eventUser: currentUser },
    })
      .then((response) => {
        console.log("response: ", response);
        if (response.status == 201) {
          toast(vocabularize("Work order created successfully"));
          setOrder(response.data);
          dispatch(setWONumber(String(response.data.number)));
        }
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const poEditHandle = (po) => {
    console.log(po);
    setCratePOModalShown(true);
    setEditingPO(po);
  };

  const handleAssignedTechsEdit = () => {
    setIsAssignTechModalShown(true);
  };

  const deleteUpload = (type) => {
    setAttachmentDeleteModalShown(false);
    WOService.deleteAttachment(order.id, attachmentToDelete.id, type)
      .then((response) => {
        console.log("🚀 ~ deleteUpload ~ response:", response);
        toast("Attachment deleted successfully");
        getWODetail(order.id);
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const sendNote = (message) => {
    const data = {
      wo: order,
      message,
      sender: currentUser,
      senderType: 0,
    };

    NoteService.createNote(data).then((response) => {
      toast("Note sent successfully");
      setOrder({ ...order, customerNotes: [...order.customerNotes, response.data] });
    });
  };

  return order ? (
    <div className="w-full px-5 pb-5">
      <AssignTechModal
        shown={isAssignTechModalShown}
        onCancelClicked={() => setIsAssignTechModalShown(false)}
        onSaveClicked={saveAssigns}
        assignedTechs={order.assignedTechs}
        branch={order.branch}
      />
      <ScheduleModal
        shown={isScheduleModalOpen}
        pStartDate={order.scheduledStartDate}
        pTargetDate={order.scheduledTargetDate}
        onSaveClicked={saveScheduledStartTargetDate}
        onCancel={() => setIsScheduleModalOpen(false)}
      />
      <CreatePoModal
        shown={cratePOModalShown}
        onCancelClicked={() => setCratePOModalShown(false)}
        onSubmitClicked={savePO}
        wo={order}
        editingPO={editingPO}
      />
      <PreviewSTModal
        shown={stPreviewModalShown}
        pdfUrl={getServiceTicketUrl(order.number)}
        cancelClicked={() => setSTPreviewModalShown(false)}
      />
      <CreateWoModal
        order={order}
        onSubmitClicked={saveWO}
        shown={isWoCreateOpen}
        onCancelClicked={() => setIsWoCreateOpen(false)}
      />
      <AttachmentImageSlider
        shown={isAttachmentSliderShown}
        attachments={sliderAttachments}
        activeIndex={sliderActiveIndex}
        onCancel={() => setIsAttachmentSliderShown(false)}
      />

      <BilledDateModal
        shown={billedDateModalShown}
        onCancel={() => setBilledDateModalShown(false)}
        pBilledDate={order.billedDate}
        pBilledNote={order.billedNote}
        onSaveClicked={(date, note) => {
          saveBilledDate(date, note);
        }}
      />

      <ConfirmDialog
        title="DELETE ATTACHMENT"
        description="Are you sure you want to delete this attachment?"
        shown={attachmentDeleteModalShown}
        onConfirmClicked={() => deleteUpload(1)}
        onCancelClicked={() => setAttachmentDeleteModalShown(false)}
      />

      <ApproveModal
        shown={approveModalShown}
        onCancelClicked={() => setApproveModalShown(false)}
        onApproveClicked={approveRequest}
      />

      <div className="w-full h-[56px] flex items-center justify-between ">
        <div className="flex items-center cursor-pointer" onClick={() => navigate(-1)}>
          <img src={getImageUrl("/images/common/back_arrow.png")} className="w-[24px]" />
          <span className="font-OpenSansRegular text-[14px] font-[700] text-subTitleColor">back</span>
        </div>
        <div className="flex items-center gap-3">
          {can("po:create") && <CreatePoButton label="Create PO" onClick={createPO} />}
          {order.status === 6 && can("wo:update") && <BlueButton title={vocabularize("CLOSE WORK ORDER")} onClicked={closeWorkOrder} />}
        </div>
      </div>

      <CustomerInformation customer={order.customer} />

      <div className="mt-3">
        <ServiceCall
          order={order}
          stPreviewLoading={stPreviewLoading}
          onEditDetails={() => setIsWoCreateOpen(true)}
          onPreviewServiceTicket={showPreviewModal}
          onViewServiceTicket={() => navigate(`/${order.id}/serviceticket`, { state: { order: order } })}
          onAddBilledDate={() => setBilledDateModalShown(true)}
          onEditAssignedTechs={handleAssignedTechsEdit}
          onAssignTechs={() => setIsAssignTechModalShown(true)}
          onApprove={() => setApproveModalShown(true)}
          onDeny={denyRequest}
        />
      </div>

      {can("wo:readAttachment") && (
        <div className="mt-3">
          <JobsitePhotos order={order} onRefresh={() => getWODetail(order.id)} />
        </div>
      )}

      {/* <div className="w-full border-solid border-[1px] border-borderColor mt-3 ">
        <div className="w-full flex items-start justify-end px-3 py-3">
          <div className="w-full flex flex-col gap-4">
            <div className="w-full flex flex-col">
              <input
                onChange={(e) => fileSelected(1, e)}
                type="file"
                id="file"
                ref={attachmentFile}
                style={{ display: "none" }}
                multiple={true}
                accept="image/*,application/pdf"
              />
              <div className="w-full flex items-center justify-between h-[30px]">
                <p className="font-OpenSansRegular font-[700] text-[12px] text-titleColor">
                  Attachments: {order.attachments?.length > 0 ? `(${order.attachments?.length})` : ""}
                </p>
              </div>

              <div
                className={`w-full rounded-[6px] border border-dashed p-3 transition-colors ${
                  isAttachmentDragActive && isAttachmentDragInvalid
                    ? "border-red-500 bg-red-50"
                    : isAttachmentDragActive
                      ? "border-blueColor bg-[#F4F8FF]"
                      : "border-borderColor"
                }`}
                onDragEnter={(e) => handleDragEnter(1, e)}
                onDragOver={(e) => handleDragOver(1, e)}
                onDragLeave={(e) => handleDragLeave(1, e)}
                onDrop={(e) => handleDrop(1, e)}
              >
                <div className="flex items-center gap-2">
                  <WhiteUploadButton isLoading={isUploadingAttachment} clicked={() => attachmentFile.current.click()} />
                  <ViewButton
                    isBlue={order.attachments?.length > 0}
                    clicked={() => {
                      order.attachments?.length > 0 &&
                        navigate(`/work/${order.id}/attachments`, { state: { woId: order.id } });
                    }}
                  />
                </div>
                <p className="mt-2 font-OpenSansRegular text-[10px] text-subTitleColor">
                  Drag and drop files here, or click upload.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* {(isManagerOver() || isAccountant()) && ( */}
      <div className="w-full flex justify-between mt-3">
        <div className="w-[49.5%] flex flex-col gap-5">
          {can("wo:readProposal") && <WoProposals order={order} onRefresh={() => getWODetail(order.id)} />}
          <WoCustomerChat order={order} sendNote={sendNote} />
          {can("wo:readAdminNote") && <WoAdminNotes woId={order.id} refreshToken={adminNotesRefreshToken} />}
          {can("wo:readTechNote") && <WoTechNotes woId={order.id} refreshToken={techNotesRefreshToken} />}
          {can("wo:readTechnicalDocument") && (
            <TechnicalDocuments order={order} onRefresh={() => getWODetail(order.id)} />
          )}
        </div>
        <div className="w-[49.5%] flex flex-col gap-5">
          {can("wo:readInvoice") && <WoInvoices order={order} onRefresh={() => getWODetail(order.id)} />}
          <WoPos
            woId={order.id}
            refreshToken={poListRefreshToken}
            navigatePODetail={navigatePODetail}
            poEditHandle={poEditHandle}
            onPreviewAttachments={(attachments, activeIndex) => openAttachmentSlider(attachments, activeIndex)}
          />
          {can("wo:readTimesheet") && <WoTimesheet order={order} />}
          <WoHistory woId={order.id} />
          {can("wo:readForm") && (
            <div>
              <WoForms
                order={order}
                onRefresh={() => getWODetail(order.id)}
                onAddForm={() => setAddFormModalShown(true)}
              />
              <AddFormModal
                shown={addFormModalShown}
                order={order}
                onClose={() => setAddFormModalShown(false)}
                onAssigned={() => getWODetail(order.id)}
                onUploaded={() => getWODetail(order.id)}
              />
            </div>
          )}
        </div>
      </div>
      {/* )} */}

      <div className="w-full flex mt-3 justify-between">
        <div className="w-[49.5%] flex flex-col gap-5"></div>
        <div className="w-[49.5%] flex flex-col gap-5"></div>
      </div>

      <div className="w-full flex justify-between mt-3">
        <div className="w-[49.5%]"></div>
      </div>
    </div>
  ) : (
    <div className="flex items-center justify-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
      <Loader variant="block" />
    </div>
  );
}

export default WODetail;
